import { FC, useEffect, useState } from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Icon, //2025.11 COMTEC kawaji ADD
} from '@chakra-ui/react';
import { Root } from 'react-dom/client';
import { WarningTwoIcon } from '@chakra-ui/icons'; //2025.11 COMTEC kawaji ADD

import { ButtonType } from '../../types/teikihoan/commonDefinition';

// プロパティ
type Props = {
  root?: Root; //ルート要素
  title: string;
  message: string | JSX.Element;
  isOpen: boolean;
  buttonType: ButtonType;
  onAccept: (e: React.FormEvent<HTMLFormElement>) => void;
  onClose: () => void;
  resolve?: (f: boolean) => void; // 確認ダイアログが閉じられたときに true または false を渡すためのコールバック関数
};

export const CommonDialog: FC<Props> = (props) => {
  // プロパティの受け取り
  const { title, message, isOpen, buttonType, onAccept, onClose } = props;

  const [dialogOpen, setDialogOpen] = useState(true);

  // 承諾（OK または YES ボタンをクリック）した時
  const handleAccept = (e: React.FormEvent<HTMLFormElement>) => {
    handleClose();
    onAccept(e);
  };

  // ダイアログクローズ
  const handleClose = () => {
    setDialogOpen(false);
    onClose();
  };

  // openの値が変化した時
  useEffect(() => setDialogOpen(isOpen), [isOpen]);

  return (
    <Modal
      closeOnOverlayClick={false}
      isOpen={dialogOpen}
      onClose={handleClose}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {/* 2025.11 COMTEC kawaji ADD START */}
          <Icon as={WarningTwoIcon} color={'yellow.400'} mr={2} boxSize={7}/>
          {/* 2025.11 COMTEC kawaji ADD END */}
          {title}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>{message}</ModalBody>

        <ModalFooter>
          {buttonType === ButtonType.OkOnly && (
            <form onSubmit={handleAccept}>
              <Button type="submit">OK</Button>
            </form>
          )}
          {buttonType === ButtonType.YesNo && (
            <>
              <form onSubmit={handleAccept}>
                <Button type="submit" mr={2}>
                  はい
                </Button>
                <Button onClick={handleClose}>いいえ</Button>
              </form>
            </>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
